import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { CookieBanner } from './CookieBanner';
import { ConsentScriptGate } from './ConsentScriptGate';

const CookieConsentContext = createContext<ReturnType<typeof useCookieConsent> | null>(null);

// eslint-disable-next-line react-refresh/only-export-components
export function useCookieConsentContext() {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) throw new Error('useCookieConsentContext must be used inside CookieConsentProvider');
  return ctx;
}

export function CookieConsentProvider({ children }: { children: ReactNode }) {
  const cookieConsent = useCookieConsent();

  return (
    <CookieConsentContext.Provider value={cookieConsent}>
      {children}
      {cookieConsent.initialized && (
        <>
          <ConsentScriptGate />
          <CookieBanner
            show={cookieConsent.showBanner}
            showPreferences={cookieConsent.showPreferences}
            consent={cookieConsent.consent}
            onAcceptAll={cookieConsent.acceptAll}
            onRejectAll={cookieConsent.rejectAll}
            onSavePreferences={cookieConsent.savePreferences}
            onOpenPreferences={cookieConsent.openPreferences}
            onSetShowPreferences={cookieConsent.setShowPreferences}
          />
        </>
      )}
    </CookieConsentContext.Provider>
  );
}
